import { trackPromise } from "react-promise-tracker";
import ParametroConsultaOperaciones from "../Contenedores/CambiosCic/ParametroConsultaOperaciones";
import { apiCambiosCic } from "../Utils/RutasApi";
import Http from "./Http";
import { tipoSolicitudCambioCic } from "../constantes/tipoSolicitudCambioCic";
import { ResultadoValidacion } from "../Contenedores/Comun/ResultadoValidacion";
import ParametroSolicitudCambioCic from "../Contenedores/CambiosCic/ParametroSolicitudCambioCic";
import ResultadoRegistroSolicitud from "../Contenedores/CambiosCic/ResultadoRegistroSolicitud";

import ParametroConsultaSolicitudesCambioCic from "../Contenedores/CambiosCic/ParametroConsultaSolicitudesCambioCic";
import ParametroConsultaDetalle from "../Contenedores/CambiosCic/ParametroConsultaDetalle";
import DetalleSolicitudCambio from "../Contenedores/CambiosCic/DetalleSolicitudCambio";
import DocumentoSolicitudCambio from "../Contenedores/CambiosCic/DocumentoSolicitudCambio";
import ParametroRechazarSolicitud from "../Contenedores/CambiosCic/ParametroRechazarSolicitud";
import ParametroAprobarSolicitud from "../Contenedores/CambiosCic/ParametroAprobarSolicitud";

interface tipoSolicitudCambioProps {
  nombreSolicitud: string;
  urlObtenerOperaciones: string;
  urlRegistrarSolicitud: string;
}

async function obtenerDatosArchivosPermitidos() {
  const url = apiCambiosCic.obtengaDatosArchivosPermitidos;
  const respuesta = await trackPromise(Http.get(url));
  const salida = respuesta.data;

  return salida;
}

function obtenerTipoSolicitudCambioCic(codigo: number) {
  const tipoSolicitud: Record<number, tipoSolicitudCambioProps> = {
    [tipoSolicitudCambioCic.TrasladarInformacionCrediticiaDeUnDeudorAOtro]: {
      nombreSolicitud: "Trasladar información crediticia de un deudor a otro",
      urlObtenerOperaciones: apiCambiosCic.obtengaOperacionesCambioDeudor,
      urlRegistrarSolicitud: apiCambiosCic.registrarSolicitudCambioDeudor,
    },
    [tipoSolicitudCambioCic.ModificarOEliminarCuotasAtrasadas]: {
      nombreSolicitud: "Modificar o Eliminar Cuotas Atrasadas",
      urlObtenerOperaciones: apiCambiosCic.obtengaOperacionesCuotasAtrasadas,
      urlRegistrarSolicitud:
        apiCambiosCic.registrarSolicitudCambioCuotasAtrasadas,
    },
    [tipoSolicitudCambioCic.ModificarOEliminarCuentasPorCobrarAsociadas]: {
      nombreSolicitud: "Modificar o Eliminar Cuentas por Cobrar Asociadas",
      urlObtenerOperaciones: apiCambiosCic.obtengaOperacionesCuentasPorCobrar,
      urlRegistrarSolicitud: apiCambiosCic.registrarSolicitudCuentasPorCobrar,
    },
    [tipoSolicitudCambioCic.IncluirMotivoDeLiquidacion]: {
      nombreSolicitud: "Incluir Motivo de Liquidación",
      urlObtenerOperaciones:
        apiCambiosCic.obtengaOperacionesIncluirMotivoLiquidacion,
      urlRegistrarSolicitud:
        apiCambiosCic.registrarSolicitudIncluirMotivoLiquidacion,
    },
    [tipoSolicitudCambioCic.ModificarMotivoDeLiquidacion]: {
      nombreSolicitud: "Modificar Motivo de Liquidación",
      urlObtenerOperaciones:
        apiCambiosCic.obtengaOperacionesModificarMotivoLiquidacion,
      urlRegistrarSolicitud:
        apiCambiosCic.registrarSolicitudModificacionMotivoLiquidacion,
    },
    [tipoSolicitudCambioCic.ExcluirOSustituirCodeudor]: {
      nombreSolicitud: "Excluir o sustituir codeudor",
      urlObtenerOperaciones: apiCambiosCic.obtengaOperacionesCambioCodeudor,
      urlRegistrarSolicitud: apiCambiosCic.registrarSolicitudCambioCodeudor,
    },
    [tipoSolicitudCambioCic.EliminarOperacion]: {
      nombreSolicitud: "Eliminar operación",
      urlObtenerOperaciones: apiCambiosCic.ObtengaOperacionesAEliminar,
      urlRegistrarSolicitud: apiCambiosCic.registrarSolicitudEliminarOperacion,
    },
  };

  return tipoSolicitud[codigo];
}

async function obtenerOperacionesCambiosCic(
  parametro: ParametroConsultaOperaciones,
  tipoSolicitud: number
) {
  const tipoSolicitudCambio = obtenerTipoSolicitudCambioCic(tipoSolicitud);

  if (!tipoSolicitudCambio) {
    const error = new ResultadoValidacion();
    error.esValido = false;
    error.errores = ["Tipo de solicitud no válido."];
    return error;
  }

  const url = tipoSolicitudCambio.urlObtenerOperaciones;
  const respuesta = await trackPromise(Http.post(url, parametro));
  const salida = respuesta.data;

  return salida;
}

function obtenerNombreSolicitudCambioCic(tipoSolicitud: number) {
  const tipoSolicitudCambio = obtenerTipoSolicitudCambioCic(tipoSolicitud);
  return tipoSolicitudCambio?.nombreSolicitud ?? "Solicitud de Cambio CIC";
}

async function registrarSolicitudCambioCic(
  parametro: ParametroSolicitudCambioCic
) {
  const tipoSolicitudCambio = obtenerTipoSolicitudCambioCic(
    parametro.tipoSolicitudCambio
  );

  if (!tipoSolicitudCambio) {
    const error = new ResultadoValidacion();
    error.esValido = false;
    error.errores = ["Tipo de solicitud no válido."];
    return error;
  }

  const url = tipoSolicitudCambio.urlRegistrarSolicitud;
  const respuesta = await trackPromise(Http.post(url, parametro));
  const salida: ResultadoRegistroSolicitud = respuesta.data;

  return salida;
}

async function ObtengaListadoSolicitudesCambioCic(
  parametro: ParametroConsultaSolicitudesCambioCic
) {
  const url = apiCambiosCic.ObtengaListadoSolicitudesCambioCic;
  const respuesta = await trackPromise(Http.post(url, parametro));
  const salida: ResultadoRegistroSolicitud = respuesta.data;
  return salida;
}

async function ObtengaDetalleSolicitudCambioCic(
  parametro: ParametroConsultaDetalle
) {
  const url = apiCambiosCic.obtengaDetalleSolicitudCambio;
  const respuesta = await trackPromise(Http.post(url, parametro));
  const salida: DetalleSolicitudCambio = respuesta.data;
  return salida;
}

async function ObtengaArchivoSolicitudCambioCic(
  parametro: DocumentoSolicitudCambio
) {
  const url = apiCambiosCic.obtengaArchivoSolicitudCambioCic;
  const respuesta = await trackPromise(Http.post(url, parametro));
  const salida: DocumentoSolicitudCambio = respuesta.data;
  return salida;
}

async function obtenerEstadosSolicitudCambio() {
  const url = apiCambiosCic.obtengaEstadosSolicitudCambio;
  const respuesta = await trackPromise(Http.get(url));
  const salida = respuesta.data;

  return salida;
}

async function RechazarUnaSolicitudCambio(
  parametro: ParametroRechazarSolicitud
) {
  const url = apiCambiosCic.RechazarSolicitud;
  const respuesta = await trackPromise(Http.post(url, parametro));
  const salida = respuesta.data;

  return salida;
}

async function EliminarUnaSolicitudCambio(parametro: any) {
  const url = apiCambiosCic.ElimineSolicitud;
  const respuesta = await trackPromise(Http.post(url, parametro));
  const salida = respuesta.data;

  return salida;
}

async function aprobarSolicitudCambio(parametro: ParametroAprobarSolicitud) {
  const url = apiCambiosCic.aprobarSolicitud;
  const respuesta = await trackPromise(Http.post(url, parametro));
  const salida = respuesta.data;

  return salida;
}

const servicioCambiosCic = {
  obtenerDatosArchivosPermitidos,
  obtenerOperacionesCambiosCic,
  obtenerNombreSolicitudCambioCic,
  registrarSolicitudCambioCic,
  ObtengaListadoSolicitudesCambioCic,
  ObtengaDetalleSolicitudCambioCic,
  ObtengaArchivoSolicitudCambioCic,
  obtenerEstadosSolicitudCambio,
  RechazarUnaSolicitudCambio,
  EliminarUnaSolicitudCambio,
  aprobarSolicitudCambio,
};

export default servicioCambiosCic;
